import AppMockupImage from './appMockup.webp'

export { AppMockupImage }
